export default "https://a.travel-assets.com/partner-portal/postcard.4b2d0bee2f32.svg";